<template>
  <div>
    <div class="container-fluid">
      <div class="row orta mt-4">
        <div class="col-md-8">
          <vx-card>
            <div class="container-fluid">
              <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="12">
                  <h4>{{ $t('nameSurname') }}: {{customer.FirstName}} {{customer.LastName}}</h4>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
                  <vs-button icon="arrow_back" to="/customers">{{ $t('back') }}</vs-button>
                </vs-col>

                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="6">
                  <vs-button icon="save" @click="updateAuthorities">{{ $t('save') }}</vs-button>
                </vs-col>
              </vs-row>

              <div class="row mt-6">
                <vs-table class="w-full" maxHeight="500px" stripe search :data="this.authorities">
                  <template slot="thead">
                    <vs-th class="colors">{{$t("authorityName")}}</vs-th>
                    <vs-th class="colors">{{$t("value")}}</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr v-for="(authority,index) in data" :key="index">
                      <vs-td>{{authority.entityName}}</vs-td>
                      <vs-td>
                        <vs-checkbox
                          v-model="authority.value"
                          color="success"
                          :vs-value="authority"
                        ></vs-checkbox>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <div class="col-md-12 mt-5">
                  <vs-pagination
                    :total="totalPage"
                    :max="9"
                    v-model="currentPage"
                    @change="selectPage"
                  ></vs-pagination>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";
import _ from "lodash";

export default {
  data() {
    return {
      customer: {
        customerUserId: "",
        FirstName: "",
        LastName: ""
      },
      currentPage: 1,
      totalPage: 0,
      authorities: []
    };
  },
  methods: {
    async selectPage(id) {
      if (this.$route.params.customerUserId == null)
        return this.$router.push("/customers");

      if (
        this.$route.params.customerUserId == null ||
        (this.$route.params.firstName == null &&
          this.$route.params.lastName == null)
      ) {
        let status = await this.getDataById();
      }

      if (id == "") id = 1;
      this.currentPage = id;

      this.customer.customerUserId = this.$route.params.customerUserId;
      this.customer.FirstName = this.$route.params.firstName;
      this.customer.LastName = this.$route.params.lastName;
      let path = "/CustomerAuthorities/getbycustomeruserid";
      http
        .post(path, {
          RequestPage: id,
          CustomerId: parseInt(this.customer.customerUserId)
        })
        .then(response => {
          this.currentPage = response.currentPage;
          this.totalPage = response.totalPage;
          this.authorities = response.data;
        });
    },
    getDataById() {
      let path = "/customers/getbyid?customerId=";
      http
        .get(
          `/customers/getbyid?customerId=${this.$route.params.customerUserId}`
        )
        .then(response => {
          this.customer.FirstName = response.firstName;
          this.customer.LastName = response.lastName;
        });
    },
    updateAuthorities() {
      var data = {
        CustomerAuthority: this.authorities.map(u => {
          return {
            authorityEntityId: u.authorityEntityId,
            customerUserId: this.customer.customerUserId,
            value: u.value
          };
        })
      };
      let pathUpdate = "/CustomerAuthorities/update";
      http.post(pathUpdate, data).then(response => {
        notify.success(this.$t("authoritiesUpdated"));

        this.$router.push("/customers");
      });
    }
  },
  created() {
    this.customer.customerUserId = this.$route.params.customerUserId;
  }
};
</script>
<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
.colors {
  background-color: rgb(218, 216, 216) !important;
}
</style>